import React from "react";
import { useHistory } from "react-router-dom";
import styles from "../../../styles/TermosUso.module.css";

const TermosUsoPage = () => {
    const history = useHistory();

    return (
        <div className={styles.container}>
            <h1 className={styles.title}>Termos de Uso</h1>

            <button className={styles.voltar} onClick={() => history.push("/")}>
                <i className="fas fa-arrow-left fa5 mr-2"></i>
                Voltar
            </button>

            <div className={styles.card}>
                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>1. Aceitação dos Termos</h2>
                    <p>
                        Ao acessar ou utilizar a plataforma <b>Sur.ia</b>, desenvolvida e operada por <b>Laon Soluções em Tecnologia LTDA</b>, inscrita no CNPJ sob nº <b>17.598.274/0001-27</b>, com sede na <b>Rua Doutor Colares, 257, Andar 2 Sala 1, Centro, Ponta Grossa – PR, 84010-010</b>, você declara ter lido, compreendido e aceitado integralmente os presentes Termos de Uso. Caso não concorde com qualquer cláusula, recomendamos que não utilize a plataforma.
                    </p>
                </section>
                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>2. Cadastro e Elegibilidade</h2>
                    <div>
                        <p>Para utilizar a plataforma, o usuário deve fornecer dados como nome, CPF, e-mail, telefone e outras informações necessárias à criação da conta. A Laon se reserva o direito de habilitar ou desabilitar funcionalidades conforme acordado previamente.</p>
                        <p>Menores de 18 anos só poderão utilizar a plataforma com autorização expressa de seus responsáveis legais.</p>
                        <p>O usuário é responsável por manter suas informações atualizadas e zelar pela confidencialidade de suas credenciais de acesso.</p>
                    </div>
                </section>
                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>3. Conduta do Usuário</h2>
                    <p>O usuário compromete-se a utilizar a plataforma de forma ética e legal, abstendo-se de:</p>
                    <ul>
                        <li>Utilizar ferramentas para fins ilícitos ou que infrinjam direitos de terceiros;</li>
                        <li>Compartilhar ou disseminar conteúdo ofensivo, difamatório, discriminatório ou ilegal;</li>
                        <li>Tentar acessar áreas ou recursos não autorizados da plataforma.</li>
                    </ul>
                    <p>A violação destas condições poderá acarretar a exclusão definitiva da conta, a critério da Laon.</p>
                </section>
                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>4. Propriedade Intelectual</h2>
                    <p>A marca, identidade visual, funcionalidades e estrutura da Sur.ia são de propriedade exclusiva da Laon Soluções em Tecnologia LTDA.</p>
                </section>
                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>5. Limitações de Uso e Isenção de Garantias</h2>
                    <p>A Sur.ia é disponibilizado "como está", sem garantias quanto à precisão, confiabilidade ou adequação dos conteúdos gerados por inteligência artificial. A Laon não se responsabiliza por decisões tomadas com base nos resultados fornecidos pela plataforma.</p>
                </section>
                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>6. Cancelamento e Encerramento</h2>
                    <p>O usuário pode solicitar o encerramento da conta a qualquer momento. A Laon poderá cancelar contas em caso de uso indevido ou descumprimento dos Termos.</p>
                </section>
                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>7. Atualizações dos Termos</h2>
                    <p>Estes Termos de Uso poderão ser modificados periodicamente. Em caso de alterações significativas, os usuários serão notificados por e-mail ou pela própria plataforma. O uso contínuo após essas mudanças implica concordância com os novos termos.</p>
                </section>
                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>8. Legislação Aplicável e Foro</h2>
                    <p>Estes termos são regidos pelas leis brasileiras. Fica eleito o foro da comarca de domicílio do usuário para a resolução de qualquer disputa relacionada à plataforma.</p>
                </section>
                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>9. Contato</h2>
                    <p>
                        Dúvidas, solicitações ou comunicações podem ser feitas através do e-mail:
                        <a href="mailto:contato@appsuria.com.br"> contato@appsuria.com.br</a>
                    </p>
                </section>
            </div>
        </div>
    );
};

export default TermosUsoPage;
